import { AavoMosaic } from "src/components/common/mosaic/AavoMosaic.tsx";
import i18n from "i18next";
import { ProjectsDataGrid } from "src/components/views/erp/project/project/ProjectsDataGrid.tsx";
import { useState } from "react";
import { ProjectView } from "src/api/generated/erp/db/types/tables/projectView.ts";
import { SubProjectsDataGrid } from "src/components/views/erp/project/subProject/SubProjectsDataGrid.tsx";
import { CenteredTypography } from "src/components/common/CenteredTypography.tsx";
import { DeliveryPackagesDataGrid } from "src/components/views/erp/delivery/deliveryPackage/DeliveryPackagesDataGrid.tsx";
import { DeliveriesDataGridBase } from "src/components/views/erp/delivery/delivery/DeliveriesDataGridBase.tsx";
import { DeliveriesDataGridApi } from "src/api/generated/erp/delivery/api/deliveriesDataGridApi.ts";
import {
	ProjectAllActivityMaterialsDataGrid
} from "src/components/views/erp/project/projectActivity/material/ProjectAllActivityMaterialsDataGrid.tsx";

export interface ProjectsContainerViewProps {
	onlyProjectId?: number;
	isActive?: boolean;
}

export const ProjectsContainerView = ({ onlyProjectId }: ProjectsContainerViewProps) => {
	const [selectedProject, setSelectedProject] = useState<ProjectView | undefined>(undefined);

	const selectProjectText = <CenteredTypography children={i18n.t("select_a_project")} />;

	return (
		<AavoMosaic
			viewId={"90B849B13AEBB19A"}
			layout={{
				type: "column",
				first: {
					type: "panel",
					title: i18n.t("projects"),
					content: <ProjectsDataGrid onlyProjectId={onlyProjectId} onSelectionChanged={setSelectedProject} />,
				},
				second: {
					type: "tabs",
					items: [
						{
							type: "panel",
							title: i18n.t("sub_projects"),
							content:
								selectedProject == null ? selectProjectText : (
									<SubProjectsDataGrid
										key={selectedProject.projectId}
										projectId={selectedProject.projectId}
									/>
								),
						},
						{
							type: "panel",
							title: i18n.t("materials"),
							content:
								selectedProject == null ? selectProjectText : (
									<ProjectAllActivityMaterialsDataGrid
										key={selectedProject.projectId}
										projectId={selectedProject.projectId}
									/>
								),
						},
						{
							type: "panel",
							title: i18n.t("packages"),
							content:
								selectedProject == null ? selectProjectText : (
									<DeliveryPackagesDataGrid
										key={selectedProject.projectId}
										gridId={"215795487EC3817C"}
										deliveryPackageSource={{
											type: "project",
											projectId: selectedProject.projectId,
										}}
									/>
								),
						},
						{
							type: "panel",
							title: i18n.t("deliveries"),
							content:
								selectedProject == null ? selectProjectText : (
									<DeliveriesDataGridBase
										key={selectedProject.projectId}
										gridId={"215795492EC3817C"}
										fetchData={({ dataModelRequest }) =>
											DeliveriesDataGridApi.getDeliveriesConnectedToProject({
												projectId: selectedProject.projectId,
												dataModelRequest: dataModelRequest,
											})
										}
									/>
								),
						},
					],
				},
			}}
		/>
	);
};
